import * as types from '../actions/types'
import Immutable from 'immutable'
import diff from 'immutablediff'
import patch from 'immutablepatch'
import moment from 'moment'
import exactMath from 'exact-math'

import {
    isPrimitive,
    cotizacion,
    documento,
    grupoItem,
    compraDirectaItem,
    getPorcentaje,
    solicitudbiitem,
    getPorcentajeFromTotal,
    foro
} from '../utils/helpers'


const INITIAL_STATE = Immutable.fromJS({
    id: null,
    estado: 0,
    solicitud: {},
    tipo_almacen: "",
    unchaged: {},
    aprobadores: [],
    btnSaveDisabled: true,
    btnRComprasDisabled: true,
    btnAproveDisabled: false,
    modified: [],
    modalCreateDocumento: {
		title: '',
		mode: '',
		show: false,
		data: null,
		btnDisabled: false,
        plantillas: [],
        garantias: [],
        unchanged: null,
        contratoanual: false,
        contratosAnuales: []
    },
    modalCreateCompraDirecta: {
        title: '',
        show: false,
        data: null,
        unchaged: null,
        bien_id: 0,
        cot_id: 0,
        bien_descripcion: '',
        bien_cantidad: 0,
    },
    addModificacion: false,
    remove: [],
    moneda: 'COP',
    comentario: {
        id: null,
        texto: null,
        btnSendDisabled: false
    }
})

export default function (state = INITIAL_STATE, action) {

    let path, nuevaCotizacion, indexBien, bien, newItem

	switch (action.type) {

        case types.ADICIONAR_MODIFICACION_SOLICITUD_BIENES_INVESTIGACION:
            state = state.set('modified', state.get('modified').filter(x => x.get('entity') + x.get('attribute') + x.get('id') !== action.payload.entity + action.payload.attribute + action.payload.id))
            state = state.update('modified', list => list.push(Immutable.fromJS(action.payload)))
            state = state.set('btnSaveDisabled', state.get('modified').count() === 0)
            return state

        case types.OBTENER_SOLICITUD_BIENES_INVESTIGACION:
			state = state.set('id', action.payload.solicitud.id)
			state = state.set('estado', action.payload.solicitud.estado)
            state = state.set('aprobadores', Immutable.fromJS(action.payload.aprobadores))
            state = state.set('solicitud', Immutable.fromJS(action.payload.solicitud))
            state = state.set('unchaged', Immutable.fromJS(action.payload.solicitud))
            state = state.set('tipo_almacen', Immutable.fromJS(action.payload.tipo_almacen))
            state = state.set('modified', INITIAL_STATE.get('modified'))
            state = state.set('btnSaveDisabled', state.get('modified').count() === 0)

            if (state.getIn(['solicitud', 'cotizaciones']).count() > 0) {
                state = state.set('moneda', state.getIn(['solicitud', 'cotizaciones',0,'moneda']))
            } else {
                state = state.set('moneda', INITIAL_STATE.get('moneda'))
            }

            return state

        case types.SELECCIONAR_MONEDA_SOLICITUD_BIENES_INVESTIGACION1:
            state = state.set('moneda', action.payload.moneda)
            state.getIn(['solicitud', 'bienes']).map((b,ib) => {
                b.get('cotizaciones').map((c,ic) => {
                    const cotizacion = c.set('moneda', action.payload.moneda)
                    state = state.setIn(['solicitud','bienes', ib, 'cotizaciones', ic], cotizacion)
                })
            })
            state = state.set('btnSaveDisabled', false)
            return state

        case types.MODIFICAR_INPUTS_SOLICITUD_BIENES_INVESTIGACION1:
        path = `${action.payload.path}`.split('.')

            if (isPrimitive(action.payload.value)) {
    			state = state.setIn(path, action.payload.value)
            } else {
                if (action.payload.immutable === false) {
                    state = state.setIn(path, action.payload.value)
                } else {
                    state = state.setIn(path, Immutable.fromJS(action.payload.value))
                }
            }

            if (action.payload.path === 'solicitud.bienes.0.fecha_cotizaciones') {
                for (let i = 0; i < state.getIn(['solicitud', 'bienes']).count(); i++) {
                    state = state.setIn(['solicitud', 'bienes', i, 'fecha_cotizaciones'], action.payload.value)
                }
            }

            // if (action.payload.path.match(/solicitud.bienes.\d.compra_directa/)) {
            //     state = state.setIn(path.slice(0,3).concat(['cotizaciones']), Immutable.fromJS([]))
            // }

            if (path[path.length-1] === 'item') {
                state = state.set('btnSaveDisabled', false)
            }

            if (action.payload.path.split('.').slice(-1)[0] == 'aiu_administracion') {

                const cotizado = getTotalSinIva(state.getIn(['modalCreateDocumento', 'data']))
                const porcentaje = state.getIn(['modalCreateDocumento', 'data', 'aiu_administracion'])
                const valor = getPorcentaje(cotizado, porcentaje)

                state = state.setIn(['modalCreateDocumento', 'data', 'aiu_administracion_value'], valor)
            }

            if (action.payload.path.split('.').slice(-1)[0] == 'aiu_imprevistos') {

                const cotizado = getTotalSinIva(state.getIn(['modalCreateDocumento', 'data']))
                const porcentaje = state.getIn(['modalCreateDocumento', 'data', 'aiu_imprevistos'])
                const valor = getPorcentaje(cotizado, porcentaje)

                state = state.setIn(['modalCreateDocumento', 'data', 'aiu_imprevistos_value'], valor)
            }

            if (action.payload.path.split('.').slice(-1)[0] == 'aiu_utilidad') {

                const cotizado = getTotalSinIva(state.getIn(['modalCreateDocumento', 'data']))
                const porcentaje = state.getIn(['modalCreateDocumento', 'data', 'aiu_utilidad'])
                const valor = getPorcentaje(cotizado, porcentaje)

                state = state.setIn(['modalCreateDocumento', 'data', 'aiu_utilidad_value'], valor)

            }

            if (action.payload.path.split('.').slice(-1)[0] == 'aiu_iva_utilidad' || action.payload.path.split('.').slice(-1)[0] == 'aiu_utilidad') {

                const utilidad = state.getIn(['modalCreateDocumento', 'data', 'aiu_utilidad_value'])
                const porcentaje = state.getIn(['modalCreateDocumento', 'data', 'aiu_iva_utilidad'])
                const valor = getPorcentaje(utilidad, porcentaje)

                state = state.setIn(['modalCreateDocumento', 'data', 'aiu_iva_utilidad_value'], valor)

            }

            if (action.payload.path.split('.').slice(-1)[0] == 'iva' && action.payload.path.split('.').indexOf("modalCreateDocumento") >= 0) {
                const cotizado = getTotalSinIva(state.getIn(['modalCreateDocumento', 'data']))
                const porcentaje = state.getIn(['modalCreateDocumento', 'data', 'iva'])
                const valor = getPorcentaje(cotizado, porcentaje)
                state = state.setIn(['modalCreateDocumento', 'data', 'iva_value'], valor)
            }

            if (action.payload.path.split('.').slice(-1)[0] == 'iva_value' && action.payload.path.split('.').indexOf("modalCreateDocumento") >= 0) {
                const cotizado = getTotalSinIva(state.getIn(['modalCreateDocumento', 'data']))
                const total_iva = state.getIn(['modalCreateDocumento', 'data', 'iva_value']) || 0
                const valor = getPorcentajeFromTotal(cotizado, total_iva)
                state = state.setIn(['modalCreateDocumento', 'data', 'iva'], valor)
            }

            if (state.getIn(['modalCreateDocumento', 'data'])) {
                const aiu_administracion_value = state.getIn(['modalCreateDocumento', 'data', 'aiu_administracion_value'])
                const aiu_imprevistos_value = state.getIn(['modalCreateDocumento', 'data', 'aiu_imprevistos_value'])
                const aiu_utilidad_value = state.getIn(['modalCreateDocumento', 'data', 'aiu_utilidad_value'])
                const aiu_iva_utilidad_value = state.getIn(['modalCreateDocumento', 'data', 'aiu_iva_utilidad_value'])
                const iva = state.getIn(['modalCreateDocumento', 'data', 'iva_value']) || 0
                const cotizado = getTotalSinIva(state.getIn(['modalCreateDocumento', 'data']))
                const aiu_total = `${aiu_administracion_value}+${aiu_imprevistos_value}+${aiu_utilidad_value}+${aiu_iva_utilidad_value}+${iva}+${cotizado}`


                state = state.setIn(['modalCreateDocumento', 'data', 'aiu_total'], exactMath.formula(aiu_total))
                // state = state.setIn(['modalCreateDocumento', 'data', 'cotizacion', 'cotizado_iva'], cotizado + aiu_total)

                if (action.payload.path.split('.').slice(-1)[0] == 'tipo') {
                    state = state.setIn(['modalCreateDocumento', 'data', 'plantilla_id'], 0)
                }

                if (action.payload.path.split('.').slice(-1)[0] == 'contratoanual') {
                    state = state.setIn(['modalCreateDocumento', 'data', 'documento_id'], null)
                    state = state.setIn(['modalCreateDocumento', 'data', 'tipo'], 0)
                    state = state.setIn(['modalCreateDocumento', 'data', 'plantilla_id'], -1)
                    state = state.setIn(['modalCreateDocumento', 'data', 'consecutivo'], '')
                }
            }

            if (action.payload.path.split('.').slice(-1)[0] == 'responsable_compras' || action.payload.path.split('.').slice(-1)[0] == 'solicitante' ) {
                state = state.set('btnRComprasDisabled', false)
            }

            // if (action.payload.path.split('.').slice(-1)[0] == 'rubro_id') {
            //     let newPath = action.payload.path.split('.')
            //     newPath = newPath.splice(0, newPath.length-1)
            //     if (newPath[newPath.length-1] == 'pivot') {
            //         state = state.setIn([...newPath, 'selected'], true)
            //     }
            // }

            if (action.payload.path.split('.').slice(-1)[0] == 'tipo_almacen'){
                if (action.payload.value === 'Laboratorio'){
                    state = state.setIn(['solicitud', 'tipo'], 6)
                } else {
                    state = state.setIn(['solicitud', 'tipo'], 7)
                }
            }

            if (action.payload.path == 'modalCreateCompraDirecta.data.proveedor') {
                state = state.setIn(['modalCreateCompraDirecta', 'data', 'razon_social'], '')
            }

            if (action.payload.path == 'modalCreateCompraDirecta.data.razon_social') {
                state = state.setIn(['modalCreateCompraDirecta', 'data', 'proveedor'], null)
            }

            return state
        case types.SELECCIONAR_TODOS_PROVEEDORES_SOLICITUD_BIENES_INVESTIGACION:
            path = `${action.payload.path}`.split('.')
            for (let i = 0; i < state.getIn(path).count(); i++) {

                state = state.setIn(path.concat([i, 'selected']), action.payload.value)
            }
            return state

        case types.ADICIONAR_GRUPO_COTIZACIONES_SOLICITUD_BIENES_INVESTIGACION:
            newItem = Immutable.fromJS(grupoItem())
            state = state.updateIn(['solicitud', 'grupo_cotizaciones'], list => list.concat([newItem]))
            return state

        case types.ADICIONAR_NUEVO_COTIZACION_PROVEEDOR_SOLICITUD_BIENES_INVESTIGACION:

            nuevaCotizacion = cotizacion()
            const fecha_entrega = moment(state.getIn(['solicitud', 'fecha_requerido'])).format('YYYY-MM-DD')
            nuevaCotizacion.fecha_entrega = fecha_entrega
            nuevaCotizacion.servicio = state.getIn(['solicitud', 'bienes', action.payload.indexServicio])
			state = state.updateIn(`${action.payload.path}`.split('.'), list => list.push(Immutable.fromJS(nuevaCotizacion)))
            return state

        case types.ADICIONAR_COTIZACION_APROBAR_PROVEEDOR_SOLICITUD_BIENES_INVESTIGACION:
            nuevaCotizacion = cotizacion()
            nuevaCotizacion.estado = 3
            state = state.updateIn(`${action.payload.path}`.split('.'), list => list.push(Immutable.fromJS(nuevaCotizacion)))
            return state




        case types.ADICIONAR_ELEMENTO_LISTA_SOLICITUD_BIENES_INVESTIGACION:

            path = action.payload.path.split('.')
            const bienes = state.getIn(path)

            bienes.map((b, i) => {

                const index = b.get('cotizaciones').findIndex(x => x.get('proveedor_id') == action.payload.value.id)

                if (b.get('selected') && b.get('cantidad_solicitada') > 0 && index == -1) {
                    const nuevacotizacion1 = cotizacion();
                    const nuevacotizacion2 = cotizacion();
                    nuevacotizacion1.proveedor_id = action.payload.value.id;
                    nuevacotizacion1.proveedore = action.payload.value;
                    nuevacotizacion2.proveedor_id = action.payload.value.id;
                    nuevacotizacion2.proveedore = action.payload.value;
                    state = state.updateIn(['solicitud', 'bienes', i, 'cotizaciones'], list => list.push(Immutable.fromJS(nuevacotizacion1)))
                    state = state.updateIn(['solicitud', 'bienes', i, 'cotizaciones'], list => list.push(Immutable.fromJS(nuevacotizacion2)))
                }

                state = state.setIn(['solicitud', 'bienes', i, 'selected'], false)

            })

            return state





        case types.REMOVER_ELEMENTO_LISTA_SOLICITUD_BIENES_INVESTIGACION:

            const index = state.getIn(['solicitud', 'bienes']).findIndex(x => x.get('id') == action.payload.bien_id)

            if (index != -1) {

                const cotizaciones =
                state.getIn(['solicitud', 'bienes', index, 'cotizaciones']).
                filter(cotizacion => cotizacion.get('proveedor_id') != action.payload.proveedor_id)

                state = state.setIn(['solicitud', 'bienes', index, 'cotizaciones'], cotizaciones)

            }

            return state



        case types.SELECCIONAR_COTIZACION_APROBAR_PROVEEDOR_SOLICITUD_BIENES_INVESTIGACION:

            let cotizacion_actual = state.getIn(['solicitud', 'bienes', action.payload.bien_idx, 'cotizaciones'])
                                        .filter(cotizacion => cotizacion.get('id') == action.payload.cotizacion_id)

            if (cotizacion_actual.count() > 0) {
                state = state.setIn(['solicitud', 'bienes', action.payload.bien_idx, 'cotizaciones_aprobar', action.payload.cotizacion_aprobar_idx], cotizacion_actual.get(0))
                state = state.setIn(['unchaged', 'bienes', action.payload.bien_idx, 'cotizaciones_aprobar', action.payload.cotizacion_aprobar_idx], cotizacion_actual.get(0))
            }
            return state

        // case types.ELIMINAR_COTIZACION_PROVEEDOR_SOLICITUD_BIENES_INVESTIGACION:
		// 	state = state.updateIn(`${action.payload.path}`.split('.'), list => list.filter(x => !x.get('selected')))
        //     return state

        case types.DESHABILITAR_BOTON_ACTUALIZAR_SOLICITUD_BIENES_INVESTIGACION:
            state = state.set('btnSaveDisabled', action.payload)
            return state

        case types.DESHABILITAR_BOTONES_APROBACION_SOLICITUD_BIENES_INVESTIGACION:
            state = state.set('btnAproveDisabled', action.payload)
            return state

        case types.ACTUALIZAR_SOLICITUD_BIENES_INVESTIGACION:
            const solicitudActualizada = action.payload.solicitud
            for (let index = 0; index < solicitudActualizada.bienes.length; index++) {
                solicitudActualizada.bienes[index].cotizaciones_aprobar = solicitudActualizada.bienes[index].cotizaciones.filter(ele => ele.estado === 4)
            }

            const ops = diff(state.get('solicitud'), Immutable.fromJS(solicitudActualizada))
            state = state.set('solicitud', patch(state.get('solicitud'), ops))
            if (ops.filter(x => x.get('path') === '/estado').count() === 1) {
                state = state.set('estado', state.getIn(['solicitud', 'estado']))
            }
            for (let i = 0; i < action.payload.aprobadores.length; i++) {
                for (let j = 0; j < action.payload.aprobadores[i].aprobaciones.length; j++) {
                    action.payload.aprobadores[i].aprobaciones[j].selected = action.payload.aprobadores[i].aprobaciones[j].estado === 2
                }
            }

            state = state.set('aprobadores', Immutable.fromJS(action.payload.aprobadores))

            state = state.set('btnRComprasDisabled', true)

            state = state.set('unchaged', state.get('solicitud'));

            state = state.set('addModificacion', false)

            state = state.set('comentario', INITIAL_STATE.get('comentario'));

            return state


        case types.CONMUTAR_RECOMENDACION_COTIZACION_BIENES_INVESTIGACION:


            const bien_id = action.payload.bien_id
            const proveedor_id = action.payload.proveedor_id

            const bien_idx = state.getIn(['solicitud', 'bienes']).findIndex(b => b.get('id') == bien_id)
            const cotizaciones = state.getIn(['solicitud', 'bienes', bien_idx, 'cotizaciones'])

            cotizaciones.map((cotizacion,cotizacion_idx) => {
                if (cotizacion.get('proveedor_id') == proveedor_id) {
                    const recomendado = !state.getIn(['solicitud', 'bienes', bien_idx, 'cotizaciones', cotizacion_idx, 'recomendado'])
                    state = state.setIn(['solicitud', 'bienes', bien_idx, 'cotizaciones', cotizacion_idx, 'recomendado'], recomendado)
                } else {
                    state = state.setIn(['solicitud', 'bienes', bien_idx, 'cotizaciones', cotizacion_idx, 'recomendado'], false)
                }
            })

            return state


        case types.CONMUTAR_SELECCION_APROBACION_BIENES_INVESTIGACION:

        const indexAprobador = state.get('aprobadores').findIndex(x => x.get('id') == action.payload.aprobador_id)
        const indexAprobacion = state.getIn(['aprobadores', indexAprobador, 'aprobaciones']).findIndex(x => x.get('id') == action.payload.aprobacion_id)
        const aprobaciones = state.getIn(['aprobadores', indexAprobador, 'aprobaciones']).filter(x => x.getIn(['cotizacione', 'bienes', 0, 'id']) == action.payload.bien_id)

        for (let i = 0; i < aprobaciones.count(); i++) {
            const index = state.getIn(['aprobadores', indexAprobador, 'aprobaciones']).findIndex(x => x.get('id') == aprobaciones.getIn([i,'id']))
            state = state.setIn(['aprobadores', indexAprobador, 'aprobaciones', index, 'estado'], 1)
        }

        state = state.setIn(['aprobadores', indexAprobador, 'aprobaciones', indexAprobacion, 'estado'], 3)

        return state




		case types.CONMUTAR_SELECCION_TODOS_BIENES:
			state.getIn(['solicitud', 'bienes']).forEach((x, n) => {
				state = state.setIn(['solicitud', 'bienes', n, 'selected'], action.payload)
			})
			return state

        case types.CALCULAR_IVA_SOLICITUD_BIENES_INVESTIGACION:
            const cotizado = getTotalSinIva(state.getIn(['modalCreateDocumento', 'data']))
            const iva_value = (getTotalConIva(state.getIn(['modalCreateDocumento', 'data'])) - getTotalSinIva(state.getIn(['modalCreateDocumento', 'data'])))
            state = state.setIn(['modalCreateDocumento', 'data', 'iva_value'], iva_value)
            state = state.setIn(['modalCreateDocumento', 'data', 'iva'], getPorcentajeFromTotal(cotizado, iva_value) || 0)
            const formula = `${state.getIn(['modalCreateDocumento', 'data', 'aiu_administracion_value'])}
                + ${state.getIn(['modalCreateDocumento', 'data', 'aiu_imprevistos_value'])}
                + ${state.getIn(['modalCreateDocumento', 'data', 'aiu_utilidad_value'])}
                + ${state.getIn(['modalCreateDocumento', 'data', 'aiu_iva_utilidad_value'])}
                + ${state.getIn(['modalCreateDocumento', 'data', 'iva_value'])}
                + ${cotizado}`
            const aiu_total = exactMath.formula(formula)
            state = state.setIn(['modalCreateDocumento', 'data', 'aiu_total'], aiu_total)
            return state


        case types.MOSTRAR_MODAL_CREAR_DOCUMENTO_SOLICITUD_BIENES_INVESTIGACION:

            state = state.setIn(['modalCreateDocumento', 'show'], action.payload.show)

            if (action.payload.show) {

                state = state.setIn(['modalCreateDocumento', 'title'], action.payload.title)
                state = state.setIn(['modalCreateDocumento', 'mode'], action.payload.mode)
                state = state.setIn(['modalCreateDocumento', 'plantillas'], Immutable.fromJS(action.payload.plantillas))
                state = state.setIn(['modalCreateDocumento', 'garantias'], Immutable.fromJS(action.payload.garantias))
                state = state.setIn(['modalCreateDocumento', 'contratosAnuales'], Immutable.fromJS(action.payload.contratos))


                if (action.payload.mode === 'create') {

                    const solicitud_id = state.get('id')
                    const documento_id = state.getIn(['solicitud', 'documentos', action.payload.indexDocumento, 'id'])
                    const proveedor_id = state.getIn(['solicitud', 'documentos', action.payload.indexDocumento, 'proveedor', 'id'])
                    state = state.setIn(['modalCreateDocumento', 'data'], Immutable.fromJS(documento(documento_id, solicitud_id, proveedor_id)))

                } else if (action.payload.mode === 'edit') {

                    state = state.setIn(['modalCreateDocumento', 'data'], state.getIn(['solicitud', 'documentos', action.payload.indexDocumento]))
                    state = state.setIn(['modalCreateDocumento', 'unchanged'], state.getIn(['solicitud', 'documentos', action.payload.indexDocumento]))
                    const tipo = state.getIn(['modalCreateDocumento', 'data', 'tipo'])

                    const creado = state.getIn(['modalCreateDocumento', 'data', 'consecutivo']) ? true : false;
                    if (!creado) {
                        state = state.setIn(['modalCreateDocumento', 'data', 'entregas_parciales'], true)
                    }

                    if (!state.getIn(['modalCreateDocumento', 'data', 'fecha_inicio']))
                        state = state.setIn(['modalCreateDocumento', 'data', 'fecha_inicio'], state.getIn(['solicitud', 'created_at']))
                    if (!state.getIn(['modalCreateDocumento', 'data', 'fecha_entrega']))
                        state = state.setIn(['modalCreateDocumento', 'data', 'fecha_entrega'], state.getIn(['solicitud', 'fecha_requerido']))

                    const cotizado = getTotalSinIva(state.getIn(['modalCreateDocumento', 'data']))
                    const aiu_adm = state.getIn(['modalCreateDocumento', 'data', 'aiu_administracion'])
                    state = state.setIn(['modalCreateDocumento', 'data', 'aiu_administracion_value'], getPorcentaje(cotizado, aiu_adm) || 0)
                    const aiu_imp = state.getIn(['modalCreateDocumento', 'data', 'aiu_imprevistos'])
                    state = state.setIn(['modalCreateDocumento', 'data', 'aiu_imprevistos_value'], getPorcentaje(cotizado, aiu_imp) || 0)
                    const aiu_uti = state.getIn(['modalCreateDocumento', 'data', 'aiu_utilidad'])
                    state = state.setIn(['modalCreateDocumento', 'data', 'aiu_utilidad_value'], getPorcentaje(cotizado, aiu_uti) || 0)
                    const aiu_iva_uti = state.getIn(['modalCreateDocumento', 'data', 'aiu_iva_utilidad'])
                    state = state.setIn(['modalCreateDocumento', 'data', 'aiu_iva_utilidad_value'], getPorcentaje(state.getIn(['modalCreateDocumento', 'data', 'aiu_utilidad_value']), aiu_iva_uti) || 0)

                    const formula = `${state.getIn(['modalCreateDocumento', 'data', 'aiu_administracion_value']) || 0}
                        + ${state.getIn(['modalCreateDocumento', 'data', 'aiu_imprevistos_value']) || 0}
                        + ${state.getIn(['modalCreateDocumento', 'data', 'aiu_utilidad_value']) || 0}
                        + ${state.getIn(['modalCreateDocumento', 'data', 'aiu_iva_utilidad_value']) || 0}
                        + ${state.getIn(['modalCreateDocumento', 'data', 'iva_value']) || 0}
                        + ${cotizado}`
                    const aiu_total = exactMath.formula(formula)

                    state = state.setIn(['modalCreateDocumento', 'data', 'aiu_total'], aiu_total)
                    state = state.setIn(['modalCreateDocumento', 'data', 'almacen'], state.get('tipo_almacen'))

                    if (tipo == 5) {
                        state = state.setIn(['modalCreateDocumento', 'contratoanual'], true)
                    }

                    if (tipo == 4) {
                        state = state.setIn(['modalCreateDocumento', 'data', 'anticipo'], 0)
                    }


                }

            } else {
                state = state.set('modalCreateDocumento', INITIAL_STATE.get('modalCreateDocumento'))
            }

            return state

        case types.MOSTRAR_MODAL_CREAR_COMPRA_DIRECTA_BIENES_INVESTIGACION:
            state = state.setIn(['modalCreateCompraDirecta', 'show'], action.payload.show)
            if (action.payload.show) {
                state = state.setIn(['modalCreateCompraDirecta', 'title'], action.payload.title)
                indexBien = state.getIn(['solicitud', 'bienes']).findIndex(bien => bien.get('id') === action.payload.bien_id)

                bien = state.getIn(['solicitud', 'bienes', indexBien])

                const facturaCompraDirecta = bien.get('factura_compra_directa')

                state = state.setIn(['modalCreateCompraDirecta', 'bien_id'], Immutable.fromJS(action.payload.bien_id))
                state = state.setIn(['modalCreateCompraDirecta', 'cot_id'], Immutable.fromJS(action.payload.cotizacion.get('id')))
                state = state.setIn(['modalCreateCompraDirecta', 'bien_descripcion'], bien.get('descripcion'))
                state = state.setIn(['modalCreateCompraDirecta', 'bien_cantidad'], bien.get('cantidad_solicitada'))

                state = state.setIn(['modalCreateCompraDirecta', 'data'], Immutable.fromJS(facturaCompraDirecta || compraDirectaItem()))
                state = state.setIn(['modalCreateCompraDirecta', 'data', 'razon_social'], action.payload.cotizacion.get('proveedor_nombre_cp'))
                state = state.setIn(['modalCreateCompraDirecta', 'unchanged'], Immutable.fromJS(facturaCompraDirecta || {}))

            }

            return state

        case types.ADICIONAR_GARANTIA_DOCUMENTO_SOLICITUD_BIENES_INVESTIGACION:
            if (action.payload.checked) {
                const garantia = state.getIn(['modalCreateDocumento', 'garantias', String(action.payload.index)])
                state = state.updateIn(['modalCreateDocumento', 'data', 'garantias'], list => list.push(garantia))
            } else {
                state = state.updateIn(['modalCreateDocumento', 'data', 'garantias'], list => list.filter(g => g.get('id') !== action.payload.id))
            }
            return state


        case types.DESHABILITAR_BOTON_MODAL_CREAR_DOCUMENTO_SOLICITUD_BIENES_INVESTIGACION:
            state = state.setIn(['modalCreateDocumento', 'btnDisabled'], action.payload)
            return state



        case types.ADICIONAR_NUEVO_ITEM_SOLICITUD_BIENES_INVESTIGACION1:
            newItem = Immutable.fromJS(solicitudbiitem())
            state = state.updateIn(['solicitud', 'bienes'], list => list.push(newItem))
            console.log(state.getIn(['solicitud']).toJS())
            return state

        case types.ELIMINAR_ITEMS_SOLICITUD_BIENES_INVESTIGACION1:
            console.log(state.getIn(['solicitud']).toJS())
            state = state.updateIn(['solicitud', 'bienes'], list => list.filter(item => !item.get('selected')))
            state = state.set('remove', action.payload.remove)
            return state


        case types.EDITAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION1:
            const indexcomentario = state.getIn(['solicitud','foros']).findIndex(c => c.get('id') === action.payload.id)
            state = state.setIn(['comentario','id'], action.payload.id)
            state = state.setIn(['comentario','texto'], state.getIn(['solicitud', 'foros', indexcomentario, 'comentario']))
            return state

        case types.DESHABILITAR_BOTON_ENVIAR_COMENTARIO_BIENES_INVESTIGACION1:
            state = state.setIn(['comentario','btnSendDisabled'], action.payload)
            return state

        case types.ENVIAR_ACTUALIZAR_COMENTARIO_SOLICITUD_BIENES_INVESTIGACION1:
            state = state.setIn(['solicitud','foros'], Immutable.fromJS(action.payload.foros))
            state = state.set('comentario', INITIAL_STATE.get('comentario'));
            return state

       	default:
            return state
	}
}

const getTotalSinIva = (data) => {
     return data.get('detalles').reduce((acum, detalle) => {
         acum += detalle.get('valor') * detalle.get('cantidad')
         return acum
     }, 0) || 0
}

const getTotalConIva = (data) => {
    return data.get('detalles').reduce((acum, detalle) => {
        acum += detalle.get('valor_con_iva') * detalle.get('cantidad')
        return acum
    }, 0) || 0
}



// WEBPACK FOOTER //
// ./src/reducers/solicitudbi.js